"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1AircrewData = exports.AFTO781V1AircrewDataFlightConditions = exports.AFTO781V1AircrewDataFlightConditionsCombatSpt = exports.AFTO781V1AircrewDataFlightConditionsCombat = exports.AFTO781V1AircrewDataFlightTime = exports.AFTO781V1AircrewDataFlightTimeTotals = void 0;
const base_model_1 = require("../../../base-model");
const afto_781_v1_aircrew_data_schema_1 = require("./afto_781_v1-aircrew-data.schema");
class AFTO781V1AircrewDataFlightTimeTotals extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataFlightTimeTotalsSchema;
    }
}
exports.AFTO781V1AircrewDataFlightTimeTotals = AFTO781V1AircrewDataFlightTimeTotals;
class AFTO781V1AircrewDataFlightTime extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataFlightTimeSchema;
    }
}
exports.AFTO781V1AircrewDataFlightTime = AFTO781V1AircrewDataFlightTime;
class AFTO781V1AircrewDataFlightConditionsCombat extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataFlightConditionsCombatSchema;
    }
}
exports.AFTO781V1AircrewDataFlightConditionsCombat = AFTO781V1AircrewDataFlightConditionsCombat;
class AFTO781V1AircrewDataFlightConditionsCombatSpt extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataFlightConditionsCombatSptSchema;
    }
}
exports.AFTO781V1AircrewDataFlightConditionsCombatSpt = AFTO781V1AircrewDataFlightConditionsCombatSpt;
class AFTO781V1AircrewDataFlightConditions extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataFlightConditionsSchema;
    }
}
exports.AFTO781V1AircrewDataFlightConditions = AFTO781V1AircrewDataFlightConditions;
class AFTO781V1AircrewData extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_aircrew_data_schema_1.afto781V1AircrewDataSchema;
    }
}
exports.AFTO781V1AircrewData = AFTO781V1AircrewData;
